import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { applyLoan } from "../../../services/user.services";
const contentData = {
  // forex: {
  //   title: "Forex Cards & Remittances",
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //   buttonLabel: "Apply Now",
  //   partners: [
  //     "/images/forex/partner1.png",
  //     "/images/forex/partner2.png",
  //     "/images/forex/partner3.png",
  //     "/images/forex/partner4.png",
  //     "/images/forex/partner5.png",
  //   ],
  // },
  // "education-loan": {
  //   title: "Education Loan",
  //   description:
  //     "Get the best education loan deals for your higher studies. Apply easily and secure your future with our trusted partners.",
  //   buttonLabel: "Apply Now",
  //   partners: [
  //     "/images/education/partner1.png",
  //     "/images/education/partner2.png",
  //     "/images/education/partner3.png",
  //     "/images/education/partner4.png",
  //   ],
  // },
  accomodation: {
    title: "Accomodation",
    contentName: "Accomodation",
    description: (
      <div class="text-gray-900 text-md leading-relaxed space-y-4">
        <h2 class="text-xl font-semibold mb-4">
          Find the Perfect Student Accommodation for Your Study Abroad Journey
        </h2>

        <p class="mb-4">
          Securing the <strong>right accommodation</strong> is essential for a
          smooth transition to studying abroad. Every country offers different
          housing options, including:
        </p>

        <ul class="list-none space-y-1 mb-6">
          <li>
            🏠 <strong>University Dorms</strong> – On-campus housing, often
            convenient but costlier.
          </li>
          <li>
            🏘️ <strong>Shared Apartments</strong> – Rent with 3–5 friends for an
            affordable option.
          </li>
          <li>
            🛏️ <strong>Private Rentals</strong> – Single or shared rooms in
            apartments near your university.
          </li>
          <li>
            🔑 <strong>Managed Student Housing</strong> – Fully furnished,
            all-inclusive housing with facilities.
          </li>
        </ul>

        <h3 class="text-lg font-semibold mb-2">
          When Should You Start Looking?
        </h3>
        <p class="mb-6">
          Once you finalize your university and location,{" "}
          <strong>start searching immediately</strong>. The best accommodations
          near campuses <strong>fill up fast</strong>, and delaying can lead to
          higher costs and limited options.
        </p>

        <h3 class="text-lg font-semibold mb-2">How We Help</h3>
        <ul class="list-none space-y-1 mb-6">
          <li>
            ✅ <strong>Connect with Trusted Accommodation Agencies</strong> – We
            work with verified agencies to get you the best prices.
          </li>
          <li>
            ✅ <strong>Find the Best Fit for Your Budget & Preferences</strong>{" "}
            – Whether it’s single rooms, shared apartments, or university
            housing, we help you choose wisely.
          </li>
          <li>
            ✅ <strong>Guarantor Assistance</strong> – If your accommodation
            requires a guarantor, our partners can assist.
          </li>
          <li>
            ✅ <strong>Connect with Seniors & Student Networks</strong> – Get
            first-hand recommendations from those already studying there.
          </li>
          <li>
            ✅ <strong>Refund Protection</strong> – If your visa is delayed or
            denied, most accommodations offer <strong>refunds</strong>, ensuring
            your money is safe.
          </li>
        </ul>

        <h3 class="text-lg font-semibold mb-2">
          Why Consider Off-Campus Housing?
        </h3>
        <p class="mb-2">
          If you're pursuing <strong>postgraduate studies</strong> or are in
          your <strong>second year of undergraduate</strong>, staying outside
          the university can save <strong>25–30% on costs</strong>. It also
          provides:
        </p>
        <ul class="list-disc list-inside mb-4">
          <li>
            <strong>More flexibility & independence</strong>
          </li>
          <li>
            <strong>Opportunities to network</strong> with students from other
            universities
          </li>
          <li>
            <strong>Fewer additional charges</strong> compared to university
            housing
          </li>
        </ul>
        <p class="mb-6">
          Let us help you find the <strong>right accommodation</strong>, at the{" "}
          <strong>best price</strong>, in the <strong>ideal location</strong>.
          <span className="font-bold text-black px-1">
            Click the button below
          </span>
          to get started with your accommodation search today! Thanks and
          Regards,
        </p>
      </div>
    ),
    buttonLabel: "Apply Now",
    partners: [
      "/images/education/partner1.png",
      "/images/education/partner2.png",
      "/images/education/partner3.png",
      "/images/education/partner4.png",
    ],
  },
  // insurance: {
  //   title: "Insurance",
  //   description:
  //     "Protect yourself and your loved ones with comprehensive insurance plans. Apply now for reliable coverage.",
  //   buttonLabel: "Apply Now",
  //   partners: [
  //     "/images/insurance/partner1.png",
  //     "/images/insurance/partner2.png",
  //     "/images/insurance/partner3.png",
  //     "/images/insurance/partner4.png",
  //     "/images/insurance/partner5.png",
  //   ],
  // },
};

const Accomodations = () => {
  const { type } = useParams(); // Extract 'type' from the URL
  const content = contentData[type] || contentData.accomodation; // Fallback to 'forex' if no match
  const [message, setMessage] = useState(""); // State for success or error message

  const handleApplyNow = async () => {
    const loanData = {
      loan_type: content.contentName, // Use title as loan_type
    };
    try {
      const response = await applyLoan(loanData); // Call the service directly
      setMessage(response.status || "Loan application submitted successfully!"); // Set success message
    } catch (error) {
      console.error("Error applying for loan:", error);
      setMessage(
        error.response?.data?.error || "An error occurred. Please try again."
      ); // Set error message
    }
  };
  return (
    <>
      <div className="flex min-h-screen p-8 justify-center">
        {/* Country Selection Section */}
        {/* <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-lg font-bold text-gray-700 mb-4">
            Choose your Country
          </h2>
          <div className="flex items-center justify-around space-x-4"> */}
        {/* Country Dropdown */}
        {/* <select className="w-full max-w-md border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500">
              <option>United States of America</option>
              <option>Canada</option>
              <option>United Kingdom</option>
              <option>Australia</option>
            </select> */}
        {/* Search Button */}
        {/* <button className="bg-green-500 text-white px-6 py-2 rounded-lg shadow-md hover:bg-green-600">
              Search
            </button>
          </div>
        </div> */}

        {/* Accommodation Links Section */}
        {/* <div className="bg-white rounded-lg mb-8 shadow-md p-6">
          <h2 className="text-lg font-bold text-gray-700 mb-4">
            Accommodation Links
          </h2>
          <ul className="space-y-2 text-blue-500">
            <li>
              <a href="#" className="hover:underline">
                Link 1
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Link 2
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Link 3
              </a>
            </li>
          </ul>
        </div> */}

        <div className="bg-white rounded-lg shadow-lg p-8 ">
          {/* Title Section */}
          <h1 className="text-2xl font-bold mb-4">{content.title}</h1>

          {/* Description */}
          <p className="text-gray-700 mb-6">{content.description}</p>

          {/* Our Partners Section */}
          {/* <h2 className="text-lg font-semibold mb-4">Our Partners</h2> */}
          {/* <div className="grid grid-cols-5 gap-4 mb-6"> */}
          {/* Partner images */}
          {/* {content.partners.map((partner, index) => (
              <img
                key={index}
                src={partner}
                alt={`Partner ${index + 1}`}
                className="h-[160px] w-40 object-cover rounded"
              />
            ))}
          </div> */}

          {/* Apply Now Button */}
          <div className="text-center">
            <button
              className="bg-green-500 text-white py-2 px-6 rounded-lg text-lg font-semibold"
              onClick={handleApplyNow} // Trigger API call
            >
              {content.buttonLabel}
            </button>
          </div>

          {/* Display success or error message */}
          {message && (
            <p
              className={`mt-4 text-lg ${
                message.includes("successfully")
                  ? "text-green-500"
                  : "text-red-500"
              }`}
            >
              {message}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default Accomodations;
